import apiFetch from '@scale/frontend-lib/api-fetch';
import type { IUserJson } from '@scale/shared/types/user';
import { INamedObjectTypes } from '@scale/shared/types/lookup';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { UserInfo } from '@scale/compass-ui/user';

function getUserProfileUrl(userId: string) {
  return `/corp/genai-ops-hub/allocation/user-lookup/${userId}`;
}

function getDisplayName(userInfo: IUserJson) {
  if (userInfo.firstName && userInfo.lastName) {
    return userInfo.firstName + ' ' + userInfo.lastName;
  } else if (userInfo.firstName) {
    return userInfo.firstName;
  } else if (userInfo.lastName) {
    return userInfo.lastName;
  } else if (userInfo.email) {
    return userInfo.email;
  } else {
    return userInfo.id;
  }
}

export default function getUserQueryOptions(
  userId: string,
): UseQueryOptions<IUserJson, Error, UserInfo> {
  return {
    queryKey: ['userInfo', userId],
    queryFn: () =>
      apiFetch<IUserJson>(null, `corp-api/lookup/preview/${INamedObjectTypes.User}/${userId}`, {
        method: 'GET',
      }),
    select: (userInfo: IUserJson): UserInfo => {
      return {
        id: userInfo.id,
        email: userInfo.email,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        displayName: getDisplayName(userInfo),
        profileUrl: getUserProfileUrl(userInfo.id),
      };
    },
  };
}
